import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function GuestRoute({ children, redirectTo = "/dashboard" }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (user) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return children;
}
